export enum Section {
  'send' = 1,
  'confirmMax' = 2,
  'confirm' = 3,
  'fields' = 4,
  'fieldsSaved' = 5,
  'auth' = 6,
  'edit' = 7,
}

export enum EditSection {
  'hub'= 0 ,
  'phone' = 1,
  'confirmPhone'= 2,
  'email' = 3,
  'confirmEmail'= 4,
  'personalData' = 5,
  'successSaved' = 6,
  'photo' = 7,
  'password' = 8,
  'zeroFields' = 9,
}
